import React, { Component, Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import { withTranslation } from "react-i18next";
import axios from "axios";
import config from "./config";
import i18n from "./i18n";
import { route } from "./routes";
import {
  withError,
  Loading,
  withRouter,
  withJobInformationApi,
  GelContentContainer,
  NotFound,
  PageTracking
} from "cw-styleguide-react";
import Utility from "./utility";
import Articles from "./routes/articles/Articles";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import Glossary from "./routes/glossary/controllers/GlossaryLandingController";
import Industries from "./routes/industries/Industries";
import Subjects from "./routes/subjects/Subjects";
import Job from "./routes/job/controllers/JobController";
import Helmet from 'react-helmet';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      jobsLoaded: false,
    };
  }

  componentDidMount() {
    this.props.jobInformationApiGetJobInformationTitles(
      i18n.language,
      (response) => {
        this.setState({
          jobs: response.data,
          jobsLoaded: true,
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  render() {
    if (!this.state.jobsLoaded) {
      return <Loading />;
    }

    return (
      <Fragment>
        <PageTracking />
        <Helmet>
          {/* Adding meta description tag for #11947 */}
          {/* https://dev.azure.com/ccdg/CWO%20-%20SEO/_workitems/edit/11947 */}
          <meta name="description" content={this.props.t("app.description")} />
        </Helmet>

        <BreadcrumbsItem to={"/"}>
          {this.props.t("route_app_title")}
        </BreadcrumbsItem>

        <Routes>
          <Route
            path={route("glossary")}
            element={<Glossary jobs={this.state.jobs} />}
          />
          <Route
            path={route("industries") + "/*"}
            element={<Industries jobs={this.state.jobs} />}
          />
          <Route
            path={route("subjects") + "/*"}
            element={<Subjects jobs={this.state.jobs} />}
          />
          <Route
            path={route("articles") + "/*"}
            element={<Articles jobs={this.state.jobs} />}
          />
          <Route
            path={route("job") + "/*"}
            element={<Job jobs={this.state.jobs} />}
          />
          <Route
            path="*"
            element={
              <GelContentContainer>
                <NotFound />
              </GelContentContainer>
            }
          />
        </Routes>
      </Fragment>
    );
  }
}

export default withJobInformationApi(
  withRouter(withError(withTranslation("local")(App)))
);
